import { Button, Frame, Page, Spinner, Stack } from '@servicetitan/design-system';
import { Header } from '../common/components/header/header';
import { observer } from 'mobx-react';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { TermsOfUseStore } from './stores/terms-of-use.store';
import { TermsOfUseApi } from './api/terms-of-use.api';
import { useEffect } from 'react';

export const TermsOfUseModule = provide({
    singletons: [TermsOfUseApi, TermsOfUseStore],
})(
    observer(() => {
        const [{ termsOfUse, isLoading, isAccepting, getTermsOfUse, acceptTermsOfUse }] =
            useDependencies(TermsOfUseStore);

        useEffect(() => {
            getTermsOfUse();
        }, [getTermsOfUse]);

        return (
            <Frame className="main-frame" header={<Header />}>
                <Page
                    maxWidth="narrow"
                    footer={
                        <Stack className="w-100" justifyContent="center">
                            <Button
                                primary
                                onClick={acceptTermsOfUse}
                                loading={isAccepting}
                                disabled={isLoading}
                                iconName="check"
                                iconPosition="right"
                            >
                                Agree and Continue
                            </Button>
                        </Stack>
                    }
                >
                    {isLoading ? (
                        <Stack justifyContent="center" alignItems="center" className="w-100 h-100">
                            <Spinner size="large" />
                        </Stack>
                    ) : (
                        <div dangerouslySetInnerHTML={{ __html: termsOfUse }} />
                    )}
                </Page>
            </Frame>
        );
    }),
);
